<!-- 物流运输单顶端部分 -->
<template>
  <div class="topForm">
    <el-form
      :model="topData"
      :rules="topDataRules"
      ref="topForm"
      label-width="120px"
      :disabled="status == '3' || status == '4'"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item :label="this.$t('transportOrderAdd.topForm.deliveryNo')" prop="deliveryNo">
            <el-input
              disabled
              :placeholder="this.$t('transportOrderAdd.topForm.deliveryNoPlaceholder')"
              v-model="topData.deliveryNo"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.topForm.deliveryCreatePersonName')"
            prop="deliveryCreatePersonName"
          >
            <el-input
              disabled
              :placeholder="
                this.$t('transportOrderAdd.topForm.deliveryCreatePersonNamePlaceholder')
              "
              v-model="topData.deliveryCreatePersonName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.topForm.deliveryCreateDate')"
            prop="deliveryCreateDate"
          >
            <el-input
              disabled
              :placeholder="this.$t('transportOrderAdd.topForm.deliveryCreateDatePlaceholder')"
              v-model="topData.deliveryCreateDate"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            class="textOver"
            :label="this.$t('transportOrderAdd.topForm.deliveryStatus')"
            prop="deliveryStatus"
          >
            <el-select
              class="widthStyle"
              filterable
              disabled
              :placeholder="this.$t('transportOrderAdd.topForm.deliveryStatusPlaceholder')"
              v-model="topData.deliveryStatus"
            >
              <el-option label="待确认" value="1"></el-option>
              <el-option label="已保存" value="2"></el-option>
              <el-option label="已作废" value="3"></el-option>
              <el-option label="已确认" value="4"></el-option>
              <el-option label="已撤销" value="5"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.topForm.deliveryLoginCompany')"
            prop="deliveryLoginCompany"
          >
            <el-input
              disabled
              :placeholder="this.$t('transportOrderAdd.topForm.deliveryLoginCompanyPlaceholder')"
              v-model="topData.deliveryLoginCompany"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.topForm.deliveryType')"
            prop="deliveryType"
          >
            <el-select
              class="widthStyle"
              filterable
              disabled
              :placeholder="this.$t('transportOrderAdd.topForm.deliveryTypePlaceholder')"
              v-model="topData.deliveryType"
            >
              <el-option label="自提" value="1"></el-option>
              <el-option label="配送" value="2"></el-option>
              <el-option label="调拨" value="3"></el-option>
              <el-option label="其他" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  export default {
    name: 'topForm',
    props: ['deliveryType', 'isEdit', 'allDetail', 'status'],
    mounted() {
      this.setDefaultData();
      if (this.status == 0) {
        const { userName, companyName } = this.userInfo;
        this.topData.deliveryCreatePersonName = userName;
        this.topData.deliveryLoginCompany = companyName;
        this.topData.deliveryCreateDate = this.getDate();
      }
    },
    computed: {
      topDataRules() {
        return {
          deliveryNo: [
            {
              required: true,
              message: this.$t('transportOrderAdd.topForm.deliveryNoPlaceholder'),
              trigger: 'blur',
            },
          ],
          deliveryCreatePersonName: [
            {
              required: true,
              message: this.$t('transportOrderAdd.topForm.deliveryCreatePersonNamePlaceholder'),
              trigger: 'blur',
            },
          ],
          deliveryCreateDate: [
            {
              required: true,
              message: this.$t('transportOrderAdd.topForm.deliveryCreateDatePlaceholder'),
              trigger: 'change',
            },
          ],
          deliveryStatus: [
            {
              required: true,
              message: this.$t('transportOrderAdd.topForm.deliveryStatusPlaceholder'),
              trigger: 'blur',
            },
          ],
          deliveryLoginCompany: [
            {
              required: true,
              message: this.$t('transportOrderAdd.topForm.deliveryLoginCompanyPlaceholder'),
              trigger: 'blur',
            },
          ],
          deliveryType: [
            {
              required: true,
              message: this.$t('transportOrderAdd.topForm.deliveryTypePlaceholder'),
              trigger: 'change',
            },
          ],
        };
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    data() {
      return {
        // 顶部表单
        topData: {
          deliveryNo: '',
          deliveryCreatePersonNo: '',
          deliveryCreatePersonName: '',
          deliveryCreateDate: '',
          deliveryStatus: '',
          deliveryLoginCompany: '',
          deliveryType: '',
        },
      };
    },
    methods: {
      // 获取当前时间
      getDate() {
        let date = new Date();
        let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
        return date.getFullYear() + '-' + month + '-' + day;
      },
      // 请求详情
      setDefaultData() {
        // 当前单据的状态
        if (this.status != 0) {
          let topData = {};
          Object.keys(this.topData).forEach((item) => {
            if (item == 'deliveryType') {
              topData[`${item}`] =
                this.allDetail.delivery[`${item}`] == undefined
                  ? ''
                  : String(this.allDetail.delivery[`${item}`]);
            } else {
              topData[`${item}`] = this.allDetail.delivery[`${item}`] || '';
            }
          });
          this.topData = {
            ...topData,
            deliveryCreatePersonNo: this.userInfo.userCode,
            deliveryCreatePersonName: this.userInfo.userName,
            deliveryLoginCompany: this.userInfo.companyName,
          };
        }
      },
      // 返回数据
      exportChildData(btnType) {
        if (btnType == '4') {
          let sign = false;
          this.$refs.topForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.topData : false;
        } else {
          return this.topData;
        }
      },
      changeDeliveryType(deliveryType) {
        this.topData.deliveryType = deliveryType;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .topForm .widthStyle {
    width: 100%;
  }
</style>
